import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject ,  Subscription } from 'rxjs';

export enum FileQueueStatus {
  Pending,
  Success,
  Error,
  Progress
}

export class FileQueueItem {
  protected statusValue: FileQueueStatus = FileQueueStatus.Pending;
  private statusValue$: BehaviorSubject<FileQueueStatus> = new BehaviorSubject(this.statusValue);

  public progress = 0;
  public request: Subscription = null;
  public response: HttpResponse<any> | HttpErrorResponse = null;

  // actions
  public cancel = () => {
    /* set in service */
  }
  public remove = () => {
    /* set in service */
  }

  // callback
  public onComplete(): () => HttpResponse<any> | HttpErrorResponse {
    return () => this.response;
  }

  // statuses
  public get status() {
    return this.statusValue$.asObservable();
  }

  public updateStatus(value: FileQueueStatus) {
    this.statusValue$.next(value);
  }
  public isPending = () => this.statusValue === FileQueueStatus.Pending;
  public isSuccess = () => this.statusValue === FileQueueStatus.Success;
  public isError = () => this.statusValue === FileQueueStatus.Error;
  public inProgress = () => this.statusValue === FileQueueStatus.Progress;

  constructor() {
    this.status.subscribe(status => (this.statusValue = status));
  }
}

export class UploadQueueItem extends FileQueueItem {
  public file: any;

  // actions
  public upload = (apiEndpoint: string, formData?: FormData) => {
    /* set in service */
  }

  // statuses
  public isUploadable = () => this.statusValue === FileQueueStatus.Pending || this.statusValue === FileQueueStatus.Error;

  constructor(file: any) {
    super();
    this.file = file;
  }
}

export class DownloadQueueItem extends FileQueueItem {
  public apiEndpoint: string;
  public file: Blob;

  // actions
  public download = () => {
    /* set in service */
  }

  // statuses
  public isDownloadable = () => this.statusValue === FileQueueStatus.Pending || this.statusValue === FileQueueStatus.Error;
  public isDownloaded = () => this.statusValue === FileQueueStatus.Success;

  constructor(apiEndpoint: string) {
    super();
    this.apiEndpoint = apiEndpoint;
  }
}
